import { SalesPriceInquiryDetail, SalesPricesInquiry, SalesPricesInquiryService } from './../../acumatica/EntityServices/SalesPricesInquiry.service';
import { CustomerIDSelectorComponent } from './../../common/customer-id-selector/customer-id-selector.component';
import { Customer } from './../../acumatica/EntityServices/Customer.service';
import { ItemSpecifications, ItemSpecsService as ItemSpecificationsService } from './../../acumatica/EntityServices/ItemSpecifications.service';
import { MayerFabricsService } from './../../services/mayer-fabrics.service';
import { MatDialog } from '@angular/material/dialog';
import { InventorySummaryInquiryService, InventorySummaryDetail } from '../../acumatica/EntityServices/InventorySummaryInquiry.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationScreen } from '../../application-navigator/application-screen';
import { AcumaticaError } from '../../acumatica/acumatica-errors';
import { StockItemService, StockItem } from '../../acumatica/EntityServices/StockItem.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { PrinterSelectDialog } from 'src/app/common/printer-selector/printer-selector.component';
import { WMSService } from 'src/app/services/wms.service';
import { environment } from 'src/environments/environment';
import { ItemPriceLookup, ItemPriceLookupService } from 'src/app/acumatica/EntityServices/ItemPriceLookup.service';
import { Adjustment, AdjustmentDetail, AdjustmentService } from 'src/app/acumatica/EntityServices/Adjustment.service';
import { AcumaticaService } from 'src/app/acumatica/acumatica.service';
import { ConfirmationDialog } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';
import { AppConfig } from 'src/app/app-config.service';

@Component({
  selector: 'item-inquiry',
  templateUrl: './item-inquiry.component.html',
  styleUrls: ['./item-inquiry.component.css']
})
export class ItemInquiryComponent extends ApplicationScreen implements OnInit {
  @ViewChild('inventoryIDField') inventoryIDField?: ElementRef;
  @ViewChild('swatchImage') swatchImage?: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;

  item?: StockItem;
  specs?: ItemSpecifications;
  inventoryID?: string;
  itemPricing?: ItemPriceLookup;
  itemPricingChange?: ItemPriceLookup;
  itemNetPrice?: number;
  levelPrices?: SalesPriceInquiryDetail[];
  levelPricesChange?: SalesPriceInquiryDetail[];
  patternItems?: StockItem[];
  public get patternItemsActive() { return this.patternItems?.filter(item => item.LifeCycle != 'Black' && item.LifeCycle != 'Red'); }
  public get patternItemsDisc() { return this.patternItems?.filter(item => item.LifeCycle == 'Black' || item.LifeCycle == 'Red'); }
  customer: Customer | null = null;
  pageTitle = "Item Inquiry";
  inventoryData = new MatTableDataSource<InventorySummaryDetail>();
  inventoryDisplayColumns = ['LocationID', 'LotSerialNbr', 'QtyAvailable'];
  environment = environment;
  pricing = AppConfig.settings.CustomerPricing;
  today = new Date();

  @ViewChild('customerSelector') customerSelector!: CustomerIDSelectorComponent;

  // #region UI template exposures
  LifeCycleColor = this.MayerFabrics.LifeCycleColor;
  LifeCycleContrastColor = this.MayerFabrics.LifeCycleContrastColor;
  // #endregion

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private stockItems: StockItemService,
    private inventorySummary: InventorySummaryInquiryService,
    private itemSpecifications: ItemSpecificationsService,
    private itemPriceLookup: ItemPriceLookupService,
    private itemSalesPriceInquiry: SalesPricesInquiryService,
    private dialog: MatDialog,
    private wms: WMSService,
    private MayerFabrics: MayerFabricsService,
    private acumatica: AcumaticaService,
    private adjustments: AdjustmentService,
  ) {
    super();
    if (environment.mode == 'wms') setTimeout(() => {
      this.inventoryDisplayColumns.push('menu');
    })
  }

  ngOnInit(): void {
    this.route.paramMap
      .subscribe(params => {
        let inventoryID = params.get('inventoryID');
        if (inventoryID) {
          this.inventoryID = inventoryID;
          this.loadItem();
        }
      });
  }

  loadItem() {
    // Clear any previous item image until the new one is loaded
    if (this.inventoryID != this.item?.InventoryID) this.swatchImage?.nativeElement.setAttribute('src', '');

    if (this.inventoryID) {
      this.stockItems.get(this.inventoryID)
        .subscribe(
          (item: StockItem) => {
            this.item = item;

            // Get Inventory & Location data
            this.loadItemInventory();

            this.itemSpecifications.get(item.PrimaryItem.ItemClassID!, { loader: null }).subscribe(specs => {
              // specs.CleaningComments = specs.CleaningComments?.replace("\n", "<br />");
              this.specs = specs;
            });

            // Get all items in this product class
            this.stockItems.getItems(`ItemClass eq '${item.PrimaryItemClassID}'`, { loader: null }).subscribe(result =>
              this.patternItems = result.sort((a, b) => (a.ColorName || a.Description!).localeCompare((b.ColorName || b.Description!)))
            );

            this.getItemPricing();

            setTimeout(() => {
              (<any>this.inventoryIDField?.nativeElement).value = '';
              this.inventoryIDField?.nativeElement.focus();
            });
          },
          (error: AcumaticaError) => {
            alert(error.message);
          }
        );
    }
  }

  public totalQtyAvailable?: number;
  loadItemInventory() {
    this.inventorySummary.get(this.item!.InventoryID!, { loader: null }).subscribe(response => {
      response.Results = response.Results.filter(row => (row.WarehouseID == "01" || row.WarehouseID == "03") && row.QtyAvailable != 0);
      this.totalQtyAvailable = response.Results.reduce((total, row) => total += row.QtyAvailable ?? 0, 0);
      this.inventoryData = new MatTableDataSource(response.Results || []);
      this.inventoryData.sort = this.sort;
    });
  }

  getItemPricing() {
    // get the selected customer's pricing
    this.itemPriceLookup.get(
      this.item!.PrimaryInventoryID,
      this.customer?.CustomerID || null,
      { loader: null }
    ).subscribe(pricing => {
      // item pricing is initially requested, and then again when the customer is selected (which may load from localStorage)
      // sometimes the customer pricing could return before the non-customer pricing
      // when that happens, don't change the itemPricing to the non-customer version

      if (this.customer && pricing.CustomerID) this.itemPricing = pricing;
      if (!this.customer && !pricing.CustomerID) this.itemPricing = pricing;
    });

    // get the level 1, 2, and 3 prices
    this.itemSalesPriceInquiry.get(new SalesPricesInquiry({
      InventoryID: this.item!.PrimaryInventoryID,
      PriceType: 'Customer Price Class'
    }), { loader: null }).subscribe(salesPrices => {
      this.levelPrices = salesPrices.Details
        ?.filter(line => line.PriceCode?.trim() == '1' || line.PriceCode?.trim() == '2' || line.PriceCode?.trim() == '3')
        .sort((a, b) => a.PriceCode!.localeCompare(b.PriceCode!))
      if (this.levelPrices && this.levelPrices.length > 0 && this.levelPrices[0].BreakQty == 0) this.itemNetPrice = this.levelPrices[0].Price;
    });

    // get the upcoming future pricing
    if(this.pricing.Effective != null) {
      // get the selected customer's pricing
      this.itemPriceLookup.getAsOf(
        this.pricing.Effective,
        this.item!.PrimaryInventoryID,
        this.customer?.CustomerID || null,
        { loader: null }
      ).subscribe(pricing => {
        if (this.customer && pricing.CustomerID) this.itemPricingChange = pricing;
        if (!this.customer && !pricing.CustomerID) this.itemPricingChange = pricing;
      });

      // get the upcoming level 1, 2, and 3 prices
      this.itemSalesPriceInquiry.get(new SalesPricesInquiry({
        InventoryID: this.item!.PrimaryInventoryID,
        PriceType: 'Customer Price Class',
        EffectiveAsOf: this.pricing.Effective,
      }), { loader: null }).subscribe(salesPrices => {
        this.levelPricesChange = salesPrices.Details
          ?.filter(line => line.PriceCode?.trim() == '1' || line.PriceCode?.trim() == '2' || line.PriceCode?.trim() == '3')
          .sort((a, b) => a.PriceCode!.localeCompare(b.PriceCode!))
        if (this.levelPricesChange && this.levelPricesChange.length > 0 && this.levelPricesChange[0].BreakQty == 0) this.itemNetPrice = this.levelPricesChange[0].Price;
      });
    }
  }

  selectCustomer(customer: Customer | null) {
    this.customer = customer;
    this.getItemPricing();
  }

  gotoItem(inventoryID: any) {
    if (!inventoryID) return;
    this.inventoryID = inventoryID.toString() || '';
    let value = this.inventoryID!.toUpperCase();

    // parse out the last part of the URL path if a URL was scanned
    if (value.startsWith("HTTP://") || value.startsWith("HTTPS://")) {
      let url = new URL(value.toLowerCase());
      let path = url.pathname.split("/");
      this.inventoryID = path[path.length - 1].toUpperCase();
    }


    this.router.navigate(['/item', this.inventoryID]);
    // repeat scanning same item, page won't navigate & refresh so explicitly reset input
    this.inventoryID = '';
  }

  printStockTag(result: InventorySummaryDetail) {
    this.dialog.open(PrinterSelectDialog)
      .afterClosed().subscribe((printer: any) => {
        if (!printer?.Printer) return;

        this.wms.printStockRollTag(
          printer.Printer.id,
          this.inventoryID!,
          result.LotSerialNbr || '',
          result.QtyAvailableForShipment!).subscribe();

      });
  }

  inventoryAdjustment(result: InventorySummaryDetail) {
    let adjustment = new AdjustmentDetail();
    adjustment.InventoryID = this.inventoryID;
    adjustment.LotSerialNbr = result.LotSerialNbr || null;
    adjustment.LocationID = result.LocationID;
    adjustment.WarehouseID = result.WarehouseID;
    adjustment.Quantity = result.QtyAvailable;

    this.acumatica.editInventoryAdjustment(adjustment).then(adjustment => {
      if (adjustment === undefined) return;

      let confirmPrompt = "Adjustment\n" +
        "Item: " + adjustment.InventoryID + "\n" + this.item!.Description + "\n" +
        "System Qty: " + ((adjustment.AdjustQtyTo || 0) - adjustment.Quantity) + "\n" +
        "Corrected Qty: " + adjustment.AdjustQtyTo + "\n" +
        "Adjustment: " + adjustment.Quantity;

      this.dialog.open(ConfirmationDialog, {
        data: {
          message: confirmPrompt
        }
      }).afterClosed().subscribe(resp => {
        if (!resp) return;

        let adjustmentDoc = new Adjustment();
        adjustmentDoc.Description = "Location Piece " + this.item!.InventoryID + " / " + adjustment.LotSerialNbr;
        adjustmentDoc.Details.push(adjustment);
        this.adjustments.put(adjustmentDoc).subscribe(postedAdjustment => {
          this.adjustments.Release(postedAdjustment).subscribe(() => {
            this.loadItemInventory();

            if (adjustment.Quantity ?? 0 == 0) return;

            this.dialog.open(PrinterSelectDialog)
              .afterClosed().subscribe((result: any) => {
                if (!result?.Printer) return;
                this.wms.printStockRollTag(result.Printer.id, this.item!.InventoryID, adjustment.LotSerialNbr || '', adjustment.AdjustQtyTo!).subscribe();
              });

          })
        })
      });
    })
  }
}

interface LotDetail {
  LotSerialNbr?: string;
  Quantity?: number;
}
class LocationItem extends StockItem {
  Lots?: LotDetail[];
  LotsTable?: MatTableDataSource<LotDetail>
}